<template>
  <div class="indexPage custom_style">
    <div class="head flex-rowl">
      <i class="iconfont icon-huiyuan"></i>
      <div class="content">
        <h1>{{ formData.id ? "编辑客户企业" : "新增客户企业" }}</h1>
        <p>客户企业管理</p>
      </div>
    </div>
    <div class="container_wrap">
      <div class="form_wrap">
        <div class="block">
          <div class="item">
            <div class="label">
              <i class="iconfont icon-bitian"></i> 客户企业名称
            </div>
            <div class="input">
              <van-field
                v-model="formData.bodyname"
                placeholder="输入客户企业名称"
              />
            </div>
          </div>
          <div class="item">
            <div class="label">企业简介</div>
            <div class="textarea">
              <van-field
                type="textarea"
                v-model="formData.bodyintro"
                placeholder="输入企业简介"
              />
            </div>
          </div>
        </div>
        <div class="block label_wrap">
          <div class="tit">所属行业</div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(4)">
              <van-field
                v-model="label1str"
                placeholder="请选择一级行业标签"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(5)">
              <van-field
                v-model="label2str"
                placeholder="请选择二级行业标签"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(6)">
              <van-field
                v-model="label3str"
                placeholder="请选择三级行业标签"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>

        <div class="block address_wrap">
          <div class="title flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(1)">
              <van-field
                v-model="bodyprovincestr"
                placeholder="选择省/直辖市"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(2)">
              <van-field
                v-model="bodycitystr"
                placeholder="选择城市"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(3)">
              <van-field
                v-model="bodyareastr"
                placeholder="选择所在区域"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item detail">
            <div class="tit">详细地址</div>
            <div class="textarea">
              <van-field
                v-model="formData.bodyaddr"
                type="textarea"
                placeholder="请填写详细地址，50个字符内"
              />
            </div>
          </div>
        </div>
        <div class="block">
          <div class="item">
            <div class="label">是否启用</div>
            <div class="radio_box">
              <van-radio-group
                v-model="formData.isuse"
                direction="horizontal"
                style="justify-content: space-evenly"
              >
                <van-radio name="1" style="margin-bottom: 15px">启用</van-radio>
                <van-radio name="0" style="margin-bottom: 15px">停用</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="custom_btn" @click="query">保存</div>
    </div>
    <!-- <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div> -->
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <!-- 弹窗 start -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          value-key="areaname"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 2">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          value-key="cityname"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          value-key="addrname"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 4">
        <van-picker
          show-toolbar
          :columns="oneLabelList"
          @confirm="onConfirm"
          value-key="labelname"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 5">
        <van-picker
          show-toolbar
          :columns="twoLabelList"
          @confirm="onConfirm"
          value-key="labelname"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 6">
        <van-picker
          show-toolbar
          :columns="threeLabelList"
          @confirm="onConfirm"
          value-key="labelname"
          @cancel="isShowPopup = false"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  encryptstringview,
  getCustomerBodyDetail,
  addCustomerBody,
  editCustomerBody,
} from "../../../api/api";
import {
  getQyFirstLevelLabel,
  getQyTwoLevelLabel,
  getQyThreeLevelLabel
} from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "customerDetail",
  data() {
    return {
      id: "",
      qyguid: "",
      type: "",
      formData: {
        id: "",
        bodyname: "",
        qyguid: "",
        bodyintro: "",
        bodyprovince: "",
        bodycity: "",
        bodyarea: "",
        bodyaddr: "",
        label1: "",
        label2: "",
        label3: "",
        isuse: "0",
        qycreateuser: "",
      },

      //   一级标签
      oneLabelList: [],
      label1str: "",
      //   二级标签
      twoLabelList: [],
      label2str: "",
      // 三级标签
      threeLabelList: [],
      label3str: "",

      provinceList: [],
      bodyprovincestr: "",
      cityList: [],
      bodycitystr: "",
      areaList: [],
      bodyareastr: '',
      loading: true,
      isShowPopup: false,
      isType: 1,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy.qyguid;
    this.formData.qycreateuser = USERINFO.truename;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getCustomerBodyDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomerBodyDetail() {
      getCustomerBodyDetail({ id: this.formData.id }).then((res) => {
        this.detail = res;
        this.formData.bodyname = res.bodyname;
        this.formData.qyguid = res.qyguid;
        this.formData.bodyintro = res.bodyintro;
        this.formData.bodyprovince = res.bodyprovince
          ? parseInt(res.bodyprovince)
          : "";
        this.formData.bodycity = res.bodycity ? parseInt(res.bodycity) : "";
        this.formData.bodyarea = res.bodyarea ? parseInt(res.bodyarea) : "";
        this.formData.bodyaddr = res.bodyaddr;
        this.formData.label1 = res.label1;
        this.formData.label2 = res.label2;
        this.formData.label3 = res.label3;
        this.formData.isuse = res.isuse;
        this.formData.qycreateuser = res.qycreateuser;
        this.bodyprovincestr = res.bodyprovincestr;
        this.bodycitystr = res.bodycitystr;
        this.bodyareastr = res.bodyareastr;
        this.label1str = res.label1str;
        this.label2str = res.label2str;
        this.label3str = res.label3str;
      });
    },

    // 获取企业一级标签
    getQyFirstLevelLabel(isClick) {
      getQyFirstLevelLabel().then((res) => {
        this.oneLabelList = res;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取二级标签
    getQyTwoLevelLabel(isClick) {
      getQyTwoLevelLabel(this.formData.label1).then((res) => {
        this.twoLabelList = res;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取三级标签
    getQyThreeLevelLabel(isClick) {
      getQyThreeLevelLabel(this.formData.label2).then((res) => {
        this.threeLabelList = res;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        this.provinceList = res;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.bodyprovince).then((res) => {
        this.cityList = res;
        this.loading = false;
        if (isClick && res.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.formData.bodycity).then((res) => {
        this.areaList = res;
        this.loading = false;
        if (isClick && res.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    onConfirm(e) {
      let { isType } = this;
      if (isType == 1) {
        this.bodyprovincestr = e.areaname;
        this.formData.bodyprovince = e.areaid;
        this.bodycitystr = "";
        this.formData.bodycity = "";
        this.bodyareastr = "";
        this.formData.bodyarea = "";
        this.formData.bodyaddr = "";
      } else if (isType == 2) {
        this.bodycitystr = e.cityname;
        this.formData.bodycity = e.cityid;
        this.bodyareastr = "";
        this.formData.bodyarea = "";
        this.formData.bodyaddr = "";
      } else if (isType == 3) {
        this.bodyareastr = e.addrname;
        this.formData.bodyarea = e.addrid;
        this.formData.bodyaddr = "";
      } else if (isType == 4) {
        this.label1str = e.labelname;
        this.formData.label1 = e.id;
        this.label2str = '';
        this.formData.label2 = '';
        this.label3str = '';
        this.formData.label3 = '';
      } else if (isType == 5) {
        this.label2str = e.labelname;
        this.formData.label2 = e.id;
        this.label3str = '';
        this.formData.label3 = '';
      } else if (isType == 6) {
        this.label3str = e.labelname;
        this.formData.label3 = e.id;
      }
      this.loading = true;
      this.isShowPopup = false;
    },
    // 显示弹窗
    handleShow(type) {
      let { bodyprovincestr, bodycitystr, label1str, label2str } = this;
      this.isType = type;
      if (type == 1) {
        this.getProvince(true);
      } else if (type == 2) {
        if (bodyprovincestr == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        this.getCity(true);
      } else if (type == 3) {
        if (bodyprovincestr == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        if (bodycitystr == "") {
          this.$toast("请选择城市");
          return;
        }
        this.getArea(true);
      }else if(type == 4) {
        this.getQyFirstLevelLabel(true)
      }else if(type == 5) {
        if (label1str == "") {
          this.$toast("请选择一级行业标签");
          return;
        }
        this.getQyTwoLevelLabel(true)
      }else if(type == 6) {
        if (label2str == "") {
          this.$toast("请选择二级行业标签");
          return;
        }
        this.getQyThreeLevelLabel(true)
      }
    },

    query() {
      let { formData } = this;
      if (formData.bodyname == "") {
        this.$toast("请输入客户企业名称");
        return;
      }

      if (formData.id) {
        this.editCustomerBody();
      } else {
        this.addCustomerBody();
      }
    },

    // 修改
    editCustomerBody() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCustomerBody(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerBody() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCustomerBody(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  /deep/ .van-cell {
    padding: 0;
    font-size: 12px;
    background: none;
    height: 100%;
  }
  /deep/ .van-field__body {
    height: 100%;
  }
  .head {
    .icon-huiyuan {
      font-size: 42px;
      font-weight: 500;
    }
  }
  .container_wrap {
    padding: 75px 83px 56px;
    .form_wrap {
      font-size: 24px;
      color: #333333;
      .customer_wrap {
        margin: 59px 13px 0;
        .label_list {
          margin-top: 30px;
          .item {
            font-size: 20px;
            color: #464646;
            height: 40px;
            border: 1px solid #d2d2d2;
            padding: 0 10px 0 20px;
            margin-right: 10px;
            min-width: 120px;
            box-sizing: border-box;
            .iconfont {
              font-size: 36px;
              margin-left: 15px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .classify_wrap {
        margin: 90px 0 110px;
      }
      .label_wrap {
        padding: 40px 0;
      }
      .tit {
        margin-bottom: 20px;
      }
      .address_wrap {
        .title {
          margin-bottom: 39px;
        }
      }
      .item {
        margin-bottom: 32px;

        .label {
          margin-bottom: 25px;
          .iconfont {
            color: #c63520;
            margin-left: -12px;
          }
        }
        .input {
          border-bottom: 1px dashed #c3c3c3;
          height: 60px;
          padding: 0 12px;
        }
        .textarea {
          height: 190px;
          background: #fafafa;
          padding: 10px 20px;
          box-sizing: border-box;
          /deep/ .van-field__control {
            height: 100%;
          }
        }
        &.detail {
          margin-top: 70px;
        }
      }
    }
    .custom_btn {
      margin-top: 200px;
      width: 280px;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>